export interface AuditLog {
  id: number;
  /// <summary>
  /// who: user
  /// </summary>
  userName: string;
  /// <summary>
  /// who: customer
  /// </summary>
  customerName: string;
  /// <summary>
  /// who: event source
  /// </summary>
  applicationName: string;

  /// <summary>
  /// what: action
  /// </summary>
  actionType: AuditActionType;
  /// <summary>
  /// what: event
  /// </summary>
  eventType: string;
  /// <summary>
  /// original event type before conversion
  /// </summary>
  originalEventType?: string;
  /// <summary>
  /// what: data primary key
  /// </summary>
  eventKey: string;
  /// <summary>
  /// what: data changes
  /// </summary>
  eventData: string;
  eventObject: any;
  /// <summary>
  /// what: event title
  /// </summary>
  eventTitle?: string;

  /// <summary>
  /// where: ip
  /// </summary>
  ipAddress: string;
  /// <summary>
  /// where: location
  /// </summary>
  latitude?: number;
  /// <summary>
  /// where: location
  /// </summary>
  longitude?: number;

  /// <summary>
  /// when
  /// </summary>
  createAt: string;
}

export interface AuditLogData {
  entities: AuditLog[];
}

export enum AuditActionType {
  Create = 'Create',
  Update = 'Update',
  Read = 'Read',
  Delete = 'Delete',
  UnDelete = 'UnDelete',
  Fail = 'Fail',
}

export enum AuditLogEvent {
  ReturnInspectionVehicleDetail = 'Vehicle',
  ReturnInspectionDamageDetail = 'Damage Line',
  ReturnInspectionDamageDetailAction = 'Labour/FR Code',
  ReturnInspectionDamageDetailPart = 'Part',
  ReturnInspectionDamageDetailImages = 'Damage Image',
  FlatRatesRequiredFailure = 'EDI',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  InspectionResultFailure = 'EDI',
}
